module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAUZJREFUOE+lk81RwzAQhZEP9tUdYCogHUAqwFSAffHPCaiAoQPf/HNxUgGhAkIHoYN0QLjaY4u3jGQkRWQ8g2Z2PNZqv31+K7Ozfy5mqy/LMnIc5x65hcjv8CzSNF2b5zVA27Z+13VvOHSB2IgIOOcBY4yAO9d1l3EcHyRIA9R1vcVhHxHmeb5Xu0EVQQj6mWXZ8gggZBfoEKgdVIhQuB/H8QENVpSbFFRVtUEHjnhOkoS++Wg1TbOAuicEg4pQA0A+VypuYRjJnRbyVPAiN5D/aT4pUAHo8Co7yAKh8GYWAIfe0eHaULDF+9VcwBqAyACQaXdi7wt5X/sEOQVsHmBkaBopDCRfzhGPABQawOa6uUcQjHAFf+QN/TXxLwDNvu/7y2EYIIwVuOKRqs76L0iYOjpM5sN2Q2cBaKye50W2G3oSMMeXb9WnoRFA+Wt3AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/icon_2.png
// module id = +zMM
// module chunks = 1